import {customElement, property} from "lit/decorators.js";
import {html, type TemplateResult} from "lit";
import {unsafeSVG} from "lit/directives/unsafe-svg.js";
import PLUS_SIGN from "../../../../../svgpictograms/plus.svg";
import Styles from "./inlineModalDialogIndicator.lit.scss";
import {DialogAnchorTemplateContent} from "./dialogAnchorTemplateContent";

const PLUS_SIGN_WITH_CLASS = PLUS_SIGN.replace("<svg", "<svg class='indicator-plus'");

@customElement("eop-inline-modal-dialog-indicator")
export class EopInlineModalDialogIndicator extends DialogAnchorTemplateContent {

    public static readonly styles = Styles;

    @property({attribute: "title"})
    public buttonTitle: string;

    public render(): TemplateResult {
        return html`
            <button @click=${this.openDialog}
                    @keydown=${this.openDialog}
                    type=button
                    class="indicator-link"
                    title=${this.buttonTitle}
            >
                    ${unsafeSVG(PLUS_SIGN_WITH_CLASS)}
            </button>`;
    }
}